module.exports = __webpack_public_path__ + "static/media/styledDatepicker-Chevrom-Left-black.d9e5d8b5.svg";